<template>
	<div class="skfaceios_help">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">使用说明</h1>
		<h3 class="doc_main_h3">
			SKFaceLite-Android SDK（精简版）使用前须知
		</h3>
		<p class="doc_main_p">1.到盛开人工智能开放平台<a href="https://www.sk-ai.com/">（https://www.sk-ai.com/）</a>注册企业账号。</p>
		<p class="doc_main_p">2.注册应用，填写平台信息、选择使用“SKFaceSDKlite”离线SDK。</p> 
		<p class="doc_main_p">3.按接口说明文档使用该SDK。</p> 
		 <h3 class="doc_main_h3">
			使用说明	
		</h3>
		 <img src="../../../static/images/objectRecognition/android/eee.png" alt="">
		<p class="doc_main_p">1.libs文件夹下为SDK，请将jar包和so库分别放到工程指定文件夹下。</p>
		<p class="doc_main_p">2.readme为更新日志。</p>
		<p class="doc_main_p">3.接口调用请参考说明文档“SKFaceLite-Android接口说明.pdf”。</p>
	
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLite-Android','使用说明'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.skfaceios_help{
	}
	.skfaceios_help{
	}
		a:hover{
		color:#00a0e9;
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacesdklite/SKFacesdkliteUserHelp.vue